export default class CaptchaData {
    public dntCaptchaImgUrl: string = "";
    public dntCaptchaId: string = "";
    public dntCaptchaTextValue: string = "";
    public dntCaptchaTokenValue: string = "";
}